import React from "react";

import LinkIcon from "@uui/LinkExternal01";

import Button from "@rui/Button";
import Link from "@rui/Link";

const LearnMoreButton = ({
  url,
  children = "Learn more",
}: {
  url: string;
  children?: React.ReactNode;
}) => {
  return (
    <Button
      variant="outlined"
      href={url}
      endIcon={<LinkIcon />}
      component={Link}
      sx={{ padding: "18px", borderColor: "shades.neutral.100" }}
    >
      {children}
    </Button>
  );
};

export default LearnMoreButton;
